// @flow
import { gql, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import * as selectors from '../selectors';

type Props = {
  onlyVersions: ?boolean,
}

type UseDeploymentHistory = (props: ?Props) => {
  activeDeployment: string,
  isFetching: boolean,
  deploymentHistory: Object[],
  refetchDeploymentHistory: () => void
}

const useDeploymentHistory: UseDeploymentHistory = (props: ?Props) => {
  const { onlyVersions = false } = props || {};
  const { data, loading, refetch } = useQuery(onlyVersions ? QUERY_VERSIONS : QUERY_ALL);

  const { activeDeployment } = useSelector(mapStateToProps(data));

  return {
    activeDeployment,
    isFetching: loading,
    deploymentHistory: data?.deploymentHistory,
    refetchDeploymentHistory: refetch
  };
}

const QUERY_VERSIONS = gql`
query getDeploymentHistoryVersions($offset: Int, $limit: Int) {
  deploymentHistory(offset: $offset, limit: $limit) {
    version
    timestamp
    gitCommitSHA
  }
}
`;
const QUERY_ALL = gql`
query getDeploymentHistory($offset: Int, $limit: Int) {
  deploymentHistory(offset: $offset, limit: $limit) {
    _id
    version
    gitCommitSHA
    isRollback
    timestamp
    deployedBy {
      username
    }
    data {
      pages {
        _id
        path
        version
        deploymentType
      }
    }
  }
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = (ownProps) => (state) => ({
  activeDeployment: selectors.selectActiveDeployment(state, ownProps)
});

export default useDeploymentHistory;
